/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Section3_Li1Inputs */

const en_about_section3_li1 = /** @type {(inputs: About_Section3_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Viewer & Explorer: Visualize JSON data in an interactive tree view with syntax highlighting`)
};

const ko_about_section3_li1 = /** @type {(inputs: About_Section3_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 뷰어 & 탐색기: 구문 강조가 포함된 인터랙티브 트리 뷰로 JSON 데이터 시각화`)
};

const ja_about_section3_li1 = /** @type {(inputs: About_Section3_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONビューアー＆エクスプローラー: シンタックスハイライト付きのインタラクティブなツリービューでJSONデータを視覚化`)
};

/**
* | output |
* | --- |
* | "JSON Viewer & Explorer: Visualize JSON data in an interactive tree view with syntax highlighting" |
*
* @param {About_Section3_Li1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const about_section3_li1 = /** @type {((inputs?: About_Section3_Li1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Section3_Li1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_about_section3_li1(inputs)
	if (locale === "ko") return ko_about_section3_li1(inputs)
	return ja_about_section3_li1(inputs)
});